(function ($) {
    class W4D_ShopHeader {
        constructor() {
            this.initSelectors()
            this.bindEvents();
        }

        initSelectors() {
            this.actionIconActiveClass = "shop-archive__actions-icon--active";
            this.viewTypeIcons = $('.shop-archive__actions-icon:has(.icon-grid), .shop-archive__actions-icon:has(.icon-table)');
            this.productsPerPageButtons = $(".shop-archive__products-per-page .shop-archive__actions-icon");
        }

        bindEvents() {
            this.viewTypeIcons.on("click", (e) => this.handleViewTypeChange(e));
            this.productsPerPageButtons.on("click", (e) => this.handleProductsPerPageChange(e));
        }

        handleViewTypeChange(e) {
            const clickedButton = $(e.currentTarget);

            if (clickedButton.hasClass(this.actionIconActiveClass)) {
                return;
            }

            this.viewTypeIcons.removeClass(this.actionIconActiveClass);
            clickedButton.addClass(this.actionIconActiveClass);

            const viewType = clickedButton.children('.icon-grid').length > 0 ? "grid" : "table";
            W4D_FrontendHelper.setCookie("products_view_type", viewType, null);

            // Use W4D_Pagination's fetchProducts method
            if (
                document.body.classList.contains("search") &&
                document.body.classList.contains("search-results")
            ) {
                window.location.reload();
            } else {
                W4D_Pagination.fetchProducts(true);
            }
        }

        handleProductsPerPageChange(e) {
            const clickedButton = $(e.currentTarget);

            if (clickedButton.hasClass(this.actionIconActiveClass)) {
                return;
            }

            this.productsPerPageButtons.removeClass(this.actionIconActiveClass);
            clickedButton.addClass(this.actionIconActiveClass);

            const productsPerPage = clickedButton.text();
            W4D_FrontendHelper.setCookie("products_per_page", productsPerPage, null);

            // Remove page parameter from URL
            const currentUrl = new URL(window.location.href);
            if (currentUrl.searchParams.has('page')) {
                currentUrl.searchParams.delete('page');
                window.history.replaceState({}, '', currentUrl.toString());
            }

            // Use W4D_Pagination's fetchProducts method
            if (
                document.body.classList.contains("search") &&
                document.body.classList.contains("search-results")
            ) {
                W4D_Pagination.fetchProducts(true);
            } else {
                W4D_Pagination.fetchProducts(true);
            }
        }
    }

    $(document).ready(function () {
        new W4D_ShopHeader;
    });

})(jQuery);